import { color, space, typography } from "styled-system";

import React from "react";
import styled from "styled-components";

const RichTextBase = styled.div`
  ${color}
  ${typography}
  ${space}
  & p, li {
    line-height: 26px;
    font-size: 16px;
  }
  & *:not(:first-child) {
    margin-top: 40px;
  }
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    font-size: 16px;
    text-transform: uppercase;
  }
  & ul {
    margin-left: 20px;
  }
  & ul {
    margin-left: 20px;
  }
  & ul li {
    list-style: disc !important;
    margin-top: 10px !important;
  }
  & ol li {
    list-style: decimal !important;
    margin-top: 10px !important;
    font-weight: bold;
  }
  & a {
    text-decoration: underline;
    transition: opacity 300ms;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
  @media (min-width: 960px) {
    & h2,
    & h3,
    & h4,
    & h5,
    & h6 {
      font-size: 24px;
    }
  }
`;

function RichText({ children, ...props }) {
  return (
    <RichTextBase
      {...props}
      dangerouslySetInnerHTML={{ __html: children }}
    ></RichTextBase>
  );
}
export default RichText;
